import React from 'react';

const Button = ({
    submit,
    disabled,
    label,
}) => (
    <div className="block w-full rounded-md shadow-sm">
        <button
            type="button"
            className="w-full flex justify-center py-2 px-4 border border-transparent
                                    text-sm font-medium rounded-md text-white bg-flotiq-600 hover:bg-flotiq-500
                                    focus:outline-none focus:border-flotiq-700 focus:shadow-outline-flotiq
                                    active:bg-flotiq-700 transition duration-150 ease-in-out
                                    disabled:opacity-75 disabled:cursor-not-allowed"
            onClick={submit}
            disabled={disabled}
        >
            {label}
        </button>
    </div>
);

export default Button;
